import { post } from "@/utils/utils";

const integrationCenter = {
  state: {
    integralList: {},
    allIntegralList: {},
    auditInfoList: {
      auditInfoModelIPage: {}
    },
    detailsIntegralGrowth: {},
    findLogList: {}
  },
  mutations: {
    QUERY_INTEGRAL_LIST(state, data) {
      state.integralList = data.result;
    },
    QUERY_ALL_INTEGRAL_LIST(state, data) {
      state.allIntegralList = data.result;
    },
    QUERY_GROWTH_INFO_LIST(state, data) {
      state.growthInfoList = data.result;
    },
    FLOW_DETAILS(state, data) {
      state.flowDetails = data.result;
    },
    ALL_FLOW_DETAILS(state, data) {
      state.allFlowDetails = data.result;
    },
    QUERY_AUDIT_INFO_LIST(state, data) {
      state.auditInfoList = data.result;
    },
    DETAILS_INTEGRAL_GROWTH(state, data) {
      state.detailsIntegralGrowth = data.result;
    },
    EDIT_INTEGRAL_GROWTH(state, data) {
      state.editIntegralGrowth = data.result;
    },
    DEL_INTEGRAL_GROWTH(state, data) {
      state.delIntegralGrowth = data.result;
    },
    QUERY_FIND_LOG_LIST(state, data) {
      state.findLogList = data.result;
    },
    QUERY_RUL_LIST(state, data) {
      state.rulList = data.result;
    },
    DETAILS_INTEGRAL_RUL(state, data) {
      state.detailsIntegralRul = data.result;
    },
    SAVE_INTEGRAL_RUL(state, data) {
      state.saveIntegralRul = data.result;
    },
    UPDATE_INTEGRAL_RUL_STATE(state, data) {
      state.updateIntegralRulState = data.result;
    },
    OPERATION_INTEGRAL_RUL_STATE(state, data) {
      state.updateIntegralRulState = data.result;
    }
  },
  actions: {
    queryIntegralList({ commit }, params) {
      return post({
        commit,
        url: `/middle/hemiaoIntegralFlowDetails/integralList`,
        name: "QUERY_INTEGRAL_LIST",
        params
      });
    },
    queryAllIntegralList({ commit }, params) {
      return post({
        commit,
        url: `/middle/hemiaoIntegralFlowDetails/integralList`,
        name: "QUERY_ALL_INTEGRAL_LIST",
        params
      });
    },
    queryGrowthInfoList({ commit }, params) {
      return post({
        commit,
        url: `/hemiaoGrowthInfo/findHemiaoGrowthInfoList`,
        name: "QUERY_GROWTH_INFO_LIST",
        params
      });
    },
    integralFlowDetails({ commit }, params) {
      return post({
        commit,
        url: `/middle/hemiaoIntegralFlowDetails/integralFlowDetailsList`,
        name: "FLOW_DETAILS",
        params
      });
    },
    allIntegralFlowDetails({ commit }, params) {
      return post({
        commit,
        url: `/middle/hemiaoIntegralFlowDetails/integralFlowDetailsList`,
        name: "ALL_FLOW_DETAILS",
        params
      });
    },
    queryAuditInfoList({ commit }, params) {
      return post({
        commit,
        url: `/integeralAndGrowth/hemiaoIntegralRewardAuditInfo/list`,
        name: "QUERY_AUDIT_INFO_LIST",
        params
      });
    },
    detailsIntegralGrowth({ commit }, params) {
      return post({
        commit,
        url: `/hemiaoGrowthInfo/findHemiaoGrowthInfoList`,
        name: "DETAILS_INTEGRAL_GROWTH",
        params
      });
    },
    editIntegralGrowth({ commit }, params) {
      return post({
        commit,
        url: `/hemiaoGrowthInfo/saveHemiaoGrowthInfoList`,
        name: "EDIT_INTEGRAL_GROWTH",
        params
      });
    },
    delIntegralGrowth({ commit }, params) {
      return post({
        commit,
        url: `/hemiaoGrowthInfo/delHemiaoGrowthInfoById`,
        name: "DEL_INTEGRAL_GROWTH",
        params
      });
    },
    queryFindLogList({ commit }, params) {
      return post({
        commit,
        url: `/hemiaoIntegralOperateLog/findLogList`,
        name: "QUERY_FIND_LOG_LIST",
        params
      });
    },
    queryRulList({ commit }, params) {
      return post({
        commit,
        url: `/hemiaoIntegralRewardRule/findRulList`,
        name: "QUERY_RUL_LIST",
        params
      });
    },
    detailsIntegralRul({ commit }, params) {
      return post({
        commit,
        url: `/hemiaoIntegralRewardRule/findHemiaoIntegralRewardRuleById`,
        name: "DETAILS_INTEGRAL_RUL",
        params
      });
    },
    saveIntegralRul({ commit }, params) {
      return post({
        commit,
        url: `/hemiaoIntegralRewardRule/saveHemiaoIntegralRewardRule`,
        name: "SAVE_INTEGRAL_RUL",
        params
      });
    },
    updateIntegralRulState({ commit }, params) {
      return post({
        commit,
        url: `/hemiaoIntegralRewardRule/updateIntegralRewardRuleState`,
        name: "UPDATE_INTEGRAL_RUL_STATE",
        params
      });
    },
    operationIntegralRulState({ commit }, params) {
      return post({
        commit,
        url: `/integeralAndGrowth/hemiaoIntegralRewardAuditInfo/operation`,
        name: "OPERATION_INTEGRAL_RUL_STATE",
        params
      });
    }
  }
};

export default integrationCenter;
